/* unplugin-vue-components disabled */import script from "./CustomerPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerPicker.vue?vue&type=script&setup=true&lang=js"

import "./CustomerPicker.vue?vue&type=style&index=0&id=5fb54f06&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fb54f06"]])

export default __exports__